import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'atn-youtube-player',
  templateUrl: './youtube-player.component.html',
  styleUrls: ['./youtube-player.component.scss']
})
export class YoutubePlayerComponent implements OnInit {
  @Input() size: 's' | 'm' | 'l' | 'xl' = 's';
  @Input() code: string;

  width: number;
  height: number;
  url: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}
  
  ngOnInit() {}

  ngOnChanges() {
    switch (this.size) {
      case 's':
        this.width = 560;
        this.height = 315;      
      break;

      case 'm':
        this.width = 640;
        this.height = 360;      
      break;

      case 'l':
        this.width = 853;
        this.height = 480;      
      break;

      case 'xl':
        this.width = 1280;
        this.height = 720;      
      break;
    }

    this.url = this.sanitizer
      .bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + this.code)
    ;   
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/youtube-player/youtube-player.component.ts